import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import useConfiguracion from '../../hooks/useConfiguracion';
import { textoPaso } from '../../utils/textosReporte';

const iconoMini = new L.DivIcon({
  className: '',
  html: '<div class="mp-pin" style="width:20px;height:20px"></div>',
  iconSize: [20, 20],
  iconAnchor: [10, 18],
});

const formatearHora = (o) => `${o.hora}:${o.minuto} ${o.periodo}`;

/**
 * Resumen final (README diseño, sección 5.8): cada tarjeta es pulsable y
 * vuelve al paso que la generó — el borrador no se pierde porque sigue
 * viviendo en `ReportWizard`, solo cambia qué paso se muestra.
 */
const PasoResumen = ({ draft, categoriaNombre, categoriaLogo, onEditarPaso, onEnviar, onVolver, enviando }) => {
  const { configuracion } = useConfiguracion();
  const texto = textoPaso(configuracion, 'resumen', {
    titulo: 'Resumen',
    subtitulo: 'Revisa antes de enviar — puedes tocar cualquier tarjeta para corregirla.',
  });
  return (
    <div className="rw-paso">
      <h2 className="rw-titulo" style={texto.estilo}>{texto.titulo}</h2>
      <p className="rw-subtitulo" style={texto.estilo}>{texto.subtitulo}</p>

      <div className="pr-tarjetas">
        <button type="button" className="pr-tarjeta" onClick={() => onEditarPaso(1)}>
          <div>
            <strong>Categoría</strong>
            <p>
              {categoriaLogo?.imagen && <img src={categoriaLogo.imagen} alt="" className="rw-categoria-logo" style={{ marginRight: 6, verticalAlign: 'middle' }} />}
              {!categoriaLogo?.imagen && categoriaLogo?.iconoPreset && (
                <i className={`fas ${categoriaLogo.iconoPreset}`} style={{ marginRight: 6 }}></i>
              )}
              {categoriaNombre || 'Sin elegir'}
            </p>
          </div>
          <span className="pr-editar">Editar</span>
        </button>

        <button type="button" className="pr-tarjeta" onClick={() => onEditarPaso(2)}>
          <div>
            <strong>Denunciante</strong>
            <p>{draft.esAnonimo ? `Anónimo${draft.alias ? ` (${draft.alias})` : ''}` : `${draft.nombres} ${draft.apellidos}`}</p>
          </div>
          <span className="pr-editar">Editar</span>
        </button>

        <button type="button" className="pr-tarjeta" onClick={() => onEditarPaso(3)}>
          <div>
            <strong>Fecha y hora de la incidencia</strong>
            <p>{draft.ocurridoEn.fecha} · {formatearHora(draft.ocurridoEn)}</p>
          </div>
          <span className="pr-editar">Editar</span>
        </button>

        <button type="button" className="pr-tarjeta pr-tarjeta-ubicacion" onClick={() => onEditarPaso(4)}>
          {draft.lat && (
            <div className="pr-minimapa">
              <MapContainer
                center={[draft.lat, draft.lng]}
                zoom={15}
                zoomControl={false}
                dragging={false}
                scrollWheelZoom={false}
                attributionControl={false}
                style={{ width: '100%', height: '100%' }}
              >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Marker position={[draft.lat, draft.lng]} icon={iconoMini} />
              </MapContainer>
            </div>
          )}
          <div><strong>Ubicación</strong><p>{draft.direccion}</p></div>
          <span className="pr-editar">Editar</span>
        </button>

        <button type="button" className="pr-tarjeta" onClick={() => onEditarPaso(5)}>
          <div>
            <strong>Evidencia</strong>
            <div className="pr-evidencia-miniaturas">
              {draft.evidencias.length === 0 && <p>Sin evidencia adjunta</p>}
              {draft.evidencias.map((ev) => (
                ev.blobUrl
                  ? <img key={ev.id} src={ev.blobUrl} alt={ev.nombre} />
                  : <div key={ev.id} className="pr-evidencia-generica"><i className="fas fa-file"></i></div>
              ))}
            </div>
          </div>
          <span className="pr-editar">Editar</span>
        </button>
      </div>

      <div className="rw-pie-fijo rw-pie-con-volver">
        <button type="button" className="rw-boton-secundario" onClick={onVolver}>Atrás</button>
        <button type="button" className="rw-boton-primario" onClick={onEnviar} disabled={enviando}>
          {enviando ? 'Enviando…' : 'Enviar reporte'}
        </button>
      </div>
    </div>
  );
};

export default PasoResumen;
